import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  toggle(event) {
    event.preventDefault()
    this.formTarget.classList.toggle('is-hidden')

    // Focus on the input when opening
    if (!this.formTarget.classList.contains('is-hidden')) {
      const input = this.formTarget.querySelector('input[type="text"]')
      if (input) {
        setTimeout(() => input.focus(), 100)
      }
    }
  }
}
